import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';

import DayPickerInput from 'react-day-picker/DayPickerInput';
import { DateUtils } from 'react-day-picker';

import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';

// Redux
import { connect } from 'react-redux';

// Redux Form
import { Field, reduxForm, formValueSelector } from 'redux-form';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import rdp from '!isomorphic-style-loader!css-loader!sass-loader!react-day-picker/lib/style.css';
import s from './BookAViewingModal.css';
import pd from '!isomorphic-style-loader!css-loader!sass-loader!./PreferredDate.css';
import c from '../../../components/commonStyle.css';
import cx from 'classnames';
import {
  Button,
  Form,
  Row,
  Col,
  FormControl,
  Modal,
  Panel
} from 'react-bootstrap';

// Helper
import validate from './validate';
import submit from './submit';

// Component
import Avatar from '../../Avatar';
import Loader from '../../Loader';

// Redux Action
import { bookAViewingClose } from '../../../actions/bookAViewing/bookAViewingModal';

// Locale
import messages from '../../../locale/messages';

class BookAViewingModal extends React.Component {
  static propTypes = {
    showBookAViewingModal: PropTypes.bool.isRequired,
    id: PropTypes.number.isRequired,
    userId: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    picture: PropTypes.string,
    profileId: PropTypes.number.isRequired,
    bookAViewingClose: PropTypes.any.isRequired,
    formatMessage: PropTypes.any
  };

  static defaultProps = {
    showBookAViewingModal: false,
    id: 0,
    userId: null,
    profileId: 0,
    city: null,
    displayName: null,
    picture: null
  };

  constructor(props) {
    super(props);
    this.renderFormControlTextArea = this.renderFormControlTextArea.bind(this);
    this.renderWarningBlock = this.renderWarningBlock.bind(this);
    this.handleDayChange = this.handleDayChange.bind(this);
    this.handleAsyncOperations = this.handleAsyncOperations.bind(this);

    this.state = {
      selectedDay: undefined,
    };
  }

  handleDayChange(selectedDay, modifiers, dayPickerInput) {
    let preferredDate = selectedDay.toISOString().slice(0, 10);
    this.setState({
      selectedDay
    });

    this.handleAsyncOperations(preferredDate);
  }

  async handleAsyncOperations(preferredDate) {
    const { formName, change } = this.props;

    await change('preferredDate', preferredDate);
  }

  renderFormControl = ({ input, label, type, placeholder, meta: { touched, error }, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl {...input} placeholder={placeholder} type={type} className={className} />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    )
  }

  renderFormControlTextArea({ input, label, meta: { touched, error }, children, className, placeholder }) {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl
          {...input}
          className={className}
          componentClass="textarea"
          placeholder={placeholder}
        >
          
          {children}
        </FormControl>
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    )
  }

  renderWarningBlock(content, error) {
    let bgClass;
    if (error) {
      bgClass = s.alertBlockError;
    } else {
      bgClass = s.alertBlockSuccess;
    }
    return (
      <div className={cx(s.alertBlock, bgClass, s.space4)}>
        <div>
          <div className={s.messageText}>
            {content}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { formatMessage } = this.props.intl;
    const { showBookAViewingModal, bookAViewingClose } = this.props;
    const { name, email, phoneNumber, preferredDate } = this.props;

    const { bookAViewingSuccess } = this.props;

    const { isLoading } = this.props;
    const { error, handleSubmit, submitting, dispatch } = this.props;
    const { isOpenOnWeekends } = this.props;

    const { locale } = this.props;

    const { selectedDay } = this.state;

    let disabled = !name || !email || !phoneNumber || !preferredDate;
    
    let loadingStatus = isLoading || false;

    let placeholderDate = new Date();
    while( !isOpenOnWeekends ) {
      if( ![0,6].includes(placeholderDate.getDay())) {
        break;
      }
      placeholderDate.setDate(placeholderDate.getDate() + 1);
    }
    let placeholder = formatDate(placeholderDate, 'L', locale);

    return (
      <div className={s.root}>
        <Modal show={showBookAViewingModal} onHide={bookAViewingClose} animation={false} className={cx(s.modalContainer, 'ContactHost')}>
          <div className={cx(s.modalTable)}>
            <div className={cx(s.modalCell)}>
              <Modal.Header className={s.modalHeading} closeButton>
                <Modal.Title><FormattedMessage {...messages.bookAViewing} /></Modal.Title>
              </Modal.Header>
              <Modal.Body bsClass={s.logInModalBody}>
                <div className={s.modalDark}>
                  <Row className={s.noMargin}>
                    {
                    bookAViewingSuccess ? <Col lg={12} md={12} sm={12} xs={12} className={s.noPadding}>
                      <Panel className={cx(s.guestModal, 'guestpanel')}>
                        <div className={s.panelBody}>
                          <div className={s.space4}>
                            <Row>
                              <Col lg={12} md={12} sm={12} xs={12}>
                                <p className={s.messagePanel} style={{textAlign: 'center'}}>
                                  <FormattedMessage {...messages.bookAViewingSuccess} />
                                </p>
                                <p className={s.messagePanel} style={{textAlign: 'center'}}>
                                  <FormattedMessage {...messages.bookAViewingBookThroughpleXpad} />
                                </p>
                                <p className={s.messagePanel} style={{textAlign: 'center'}}>
                                  <Button className={cx(c.btnPrimary, c.btnShadow)} onClick={() => bookAViewingClose()}>
                                    <FormattedMessage {...messages.close} />
                                  </Button>
                                </p>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Panel>
                    </Col>
                    :
                    <Col lg={12} md={12} sm={12} xs={12} className={s.noPadding}>
                      <Loader
                        show={loadingStatus}
                        type={"page"}
                      >
                        <Panel className={cx(s.guestModal, 'guestpanel')}>
                          <div className={s.panelBody}>
                            <div className={s.space4}>
                              <Row>
                                <Form onSubmit={handleSubmit(submit)}>
                                  <Col lg={12} md={12} sm={12} xs={12}>
                                    <div className={s.messagePanel}>
                                      <label className={c.inputLabelText}>
                                        <FormattedMessage {...messages.bookAViewingName} />
                                      </label>
                                      <Field
                                        name="name"
                                        label={formatMessage(messages.bookAViewingName)}
                                        component={this.renderFormControl}
                                        className={cx(c.commonControlInput)}
                                        placeholder={formatMessage(messages.bookAViewingNamePlaceholder)}
                                      />
                                    </div>
                                  </Col>
                                  <Col lg={12} md={12} sm={12} xs={12} className={s.spaceTop2}>
                                    <div className={s.messagePanel}>
                                      <label className={c.inputLabelText}>
                                        <FormattedMessage {...messages.bookAViewingCompanyName} />
                                      </label>
                                      <Field
                                        name="companyName"
                                        component={this.renderFormControl}
                                        className={cx(c.commonControlInput)}
                                        placeholder={formatMessage(messages.bookAViewingCompanyNamePlaceholder)}
                                      />
                                    </div>
                                  </Col>
                                  <Col lg={12} md={12} sm={12} xs={12} className={s.spaceTop2}>
                                    <div className={s.messagePanel}>
                                      <label className={c.inputLabelText}>
                                        <FormattedMessage {...messages.bookAViewingEmail} />
                                      </label>
                                      <Field
                                        name="email"
                                        component={this.renderFormControl}
                                        className={cx(c.commonControlInput)}
                                        placeholder={formatMessage(messages.bookAViewingEmailPlaceholder)}
                                      />
                                    </div>
                                  </Col>
                                  <Col lg={12} md={12} sm={12} xs={12} className={s.spaceTop2}>
                                    <div className={s.messagePanel}>
                                      <label className={c.inputLabelText}>
                                        <FormattedMessage {...messages.bookAViewingPhoneNumber} />
                                      </label>
                                      <Field
                                        name="phoneNumber"
                                        component={this.renderFormControl}
                                        className={cx(c.commonControlInput)}
                                        placeholder={formatMessage(messages.bookAViewingPhoneNumberPlaceholder)}
                                      />
                                    </div>
                                  </Col>
                                  <Col lg={12} md={12} sm={12} xs={12} className={s.spaceTop2}>
                                    <label className={c.inputLabelText}>
                                      <FormattedMessage {...messages.bookAViewingPreferredDate} />
                                    </label>
                                    <div className={'preferredDate'}>
                                      <DayPickerInput
                                        value={selectedDay}
                                        /* classNames={{container: 'input__SelectedMonth',
                                                    overlay: 'DayPicker-Overlay'}} */
                                        component={props => <input className={cx(c.commonControlInput, c.fullWidth)} {...props} />}
                                        formatDate={formatDate}
                                        parseDate={parseDate}
                                        format={'L'}
                                        placeholder={placeholder}
                                        onDayChange={this.handleDayChange}
                                        /* showOverlay={true} */
                                        dayPickerProps={{
                                          numberOfMonths: 1,
                                          firstDayOfWeek: 1,
                                          locale: locale,
                                          localeUtils: MomentLocaleUtils,
                                          selectedDays: selectedDay,
                                          showOutsideDays: true,
                                          /* onDayClick: this.handleMonthPassDayClick,
                                          onDayMouseEnter: this.handleDayEnter,
                                          onDayMouseLeave: this.handleDayLeave, */
                                          disabledDays: [DateUtils.isPastDay, ...!isOpenOnWeekends ? [{daysOfWeek: [0, 6]}] : []]}}
                                      />
                                    </div>
                                  </Col>
                                  <Col lg={12} md={12} sm={12} xs={12} className={s.spaceTop2}>
                                    <div className={s.messagePanel}>
                                      <label className={c.inputLabelText}>
                                        <FormattedMessage {...messages.bookAViewingMessage} />
                                      </label>
                                      <Field
                                        name="message"
                                        component={this.renderFormControlTextArea}
                                        className={cx(c.commonControlInput)}
                                        placeholder={formatMessage(messages.bookAViewingMessagePlaceholder)}
                                      />
                                    </div>
                                  </Col>
                                  <Col lg={12} md={12} sm={12} xs={12} className={s.spaceTop2}>
                                    <Button className={cx(c.btnPrimary, c.btnLarge, c.fullWidth)} type="submit" disabled={submitting || disabled}>
                                      <FormattedMessage {...messages.bookAViewingSendRequest} />
                                    </Button>
                                  </Col>
                                </Form>
                              </Row>
                            </div>
                          </div>
                        </Panel>
                      </Loader>
                    </Col>
                    }
                  </Row>
                </div>
              </Modal.Body>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

BookAViewingModal = reduxForm({
  form: "BookAViewingForm", // a unique name for this form
  validate
})(BookAViewingModal);

// Decorate with connect to read form values
const selector = formValueSelector('BookAViewingForm'); // <-- same as form name

const mapState = (state) => ({
  isLoading: state.viewListing.isLoading,
  showBookAViewingModal: state.viewListing.showBookAViewingModal,
  bookAViewingSuccess: state.viewListing.bookAViewingSuccess,
  locale: state.intl.locale,
  name: selector(state, 'name'),
  email: selector(state, 'email'),
  phoneNumber: selector(state, 'phoneNumber'),
  preferredDate: selector(state, 'preferredDate'),
});

const mapDispatch = {
  bookAViewingClose
};

export default injectIntl(withStyles(s, c, rdp, pd)(connect(mapState, mapDispatch)(BookAViewingModal)));




// WEBPACK FOOTER //
// src/components/ViewListing/BookAViewingModal/BookAViewingModal.js